import { BLink } from '../../../vendor/bootstrap-vue/src/components/link/link';
import { SafeLinkMixin } from '../../mixins/safe_link_mixin';
import { isExternalURL } from '../../../directives/safe_link/safe_link';
import { linkVariantOptions } from '../../../utils/constants';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

//
var script = {
  name: 'GlLink',
  components: {
    BLink
  },
  mixins: [SafeLinkMixin],
  props: {
    /**
     * If inline variant, controls ↗ character visibility
     */
    showExternalIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Link variant
     */
    variant: {
      type: String,
      required: false,
      default: null,
      validator: value => value && Object.hasOwn(linkVariantOptions, value)
    }
  },
  computed: {
    isInlineAndHasExternalIcon() {
      return this.showExternalIcon && this.variant === 'inline' && this.$attrs.href && isExternalURL(this.target, this.$attrs.href);
    },
    linkClasses() {
      return ['gl-link', linkVariantOptions[this.variant], {
        'gl-link-inline-external': this.isInlineAndHasExternalIcon
      }];
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',_vm._g(_vm._b({directives:[{name:"safe-link",rawName:"v-safe-link:[safeLinkConfig]",arg:_vm.safeLinkConfig}],class:_vm.linkClasses,attrs:{"target":_vm.target}},'b-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
